module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/038-cape-verde-5611ebfde046b728b969d5b644296c11.svg";